import { Component, ViewChild, TemplateRef, Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserService } from '../../../services/user.service';
import { FormService } from 'src/app/services/form.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { Form, FormControl, Validators } from '@angular/forms';
import { PerfilComponent } from '../../perfil/perfil.component';
import { Observable, BehaviorSubject } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Propiedades } from 'src/app/models/propiedades.model';
import { Http } from '@angular/http';
import * as moment from 'moment';
import { GLOBAL } from 'src/app/services/global';
import { DetalleTotemComponent } from '../detalle-totem/detalle-totem.component';


declare const swal: any;

interface AppState {
    form: Form;
}


@Component({
    selector: "page-busqueda_dir",
    templateUrl: "busqueda_dir.component.html",
    styleUrls: ["./busqueda_dir.component.css"],
    providers: [UserService, FormService]
})

export class Busqueda_dirComponent {

    public errorMessage = ''
    displayedColumns: string[] = ['Propiedad_Direccion::PDI_Calle_Nombre', 'Propiedad_Direccion::PDI_Num_Calle', 'Propiedad_Direccion::PDI_Num_Ex', 'Propiedad_Direccion::PDI_Direc_Complemento_Tipo', 'Propiedad_Direccion::PDI_Direc_Complemento_Num', 'Propiedad_Direccion::PDI_Anexo', 'Propiedad_Direccion::PDI_Anexo_Num']
    public certificado_info
    public arreglo
    buscando = false
    public rol = new FormControl('', [Validators.required]);
    public calle = new FormControl('', [Validators.required]);
    public nroCalle = new FormControl('', [Validators.required]);
    public nombre_conjunto = new FormControl('', [Validators.required]);
    public fecha_ingreso = new FormControl('', [Validators.required]);
    public comunaMapa = GLOBAL.comunaMapa;
    marcadores: Marcador[] = [];
    public dataBusqueda = ""
    public verDetalle = false
    public detalleSeleccionado

    public resultados = []
    public type = ""

    public Propiedades: Propiedades;
    public direcciones: MatTableDataSource<Propiedades>;
    documentos: MatTableDataSource<any>;
    dataCips: MatTableDataSource<any>;

    identity
    token


    //coordenadas del centro de Colina //la florida
    public lat: number = -33.202472    //-33.53071445
    public lng: number = -70.6749147   //-70.54402715
    public nombreMarker: string = ''

    constructor(private _snackBar: MatSnackBar, private dialog: MatDialog, private store: Store<AppState>, private _user: UserService, private spinner: NgxSpinnerService, private _cd: ChangeDetectorRef, public http: Http) {

    }





    buscar() {

        this.spinner.show()
        if (this.rol.valid) {
            this._user.buscar_direc_all({ rol: this.rol.value }).subscribe(response => {
                this.spinner.hide();
                this.type = "predio";
                console.log(response)
                if (response.done) {
                    this.buscando = true
                    this.dataBusqueda = this.rol.value
                    let fechax
                    let fechay

                    let data = response.body.response.data
                    // fechax = data['Conj_Hab_Resoluciones::CHRS_Resol_Fecha']
                    // fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
                    // if (fechay == "Invalid date") { fechay = "" }
                    // data[0].fieldData['TEd_FechaCreacion'] = fechay
                    // this.resultados = [...data];
                    console.log(this.resultados)


                    data.map(resultado => {
                        resultado.portalData.Propiedad_Direccion.map(direccion => {

                            this.resultados.push({
                                rol: resultado.fieldData.Pro_ROL,
                                info: resultado,
                                direccion: direccion
                            })
                        })
                    })

                    console.log(this.resultados)
                } else {
                    if (response.code == 404) {
                        swal({
                            type: 'warning',
                            title: "No hay resultados",
                            text: response.message,
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500,
                            onClose: () => {
                            }
                        }).then(() => {
                        }, (dismiss) => {
                        });
                    } else if (response.code == 500) {
                        swal({
                            type: 'warning',
                            title: 'Ha ocurrido un problema!',
                            text: response.message,
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500,
                            onClose: () => {
                                window.close()
                                // window.location.reload();
                            }
                        }).then(() => {
                        }, (dismiss) => {
                            window.close()
                            // window.location.reload();
                        });
                    }

                }
            }, error => {
                console.log(error)
                this.spinner.hide()
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                })
                this.spinner.hide()
            })
        } else if (this.calle.valid && this.nroCalle.valid) {
            this._user.buscar_direc_all({ direccion: { calle: this.calle.value, num: this.nroCalle.value } }).subscribe(response => {
                this.spinner.hide()
                this.type = "predio";
                console.log(response)
                if (response.done) {
                    this.buscando = true
                    this.dataBusqueda = `${this.calle.value} N° ${this.nroCalle.value}`

                    let data = response.body.response.data
                    console.log(this.resultados)

                    data.map(resultado => {
                        resultado.portalData.Propiedad_Direccion.map(direccion => {

                            this.resultados.push({
                                rol: resultado.fieldData.Pro_ROL,
                                info: resultado,
                                direccion: direccion
                            })
                        })
                    })
                } else {
                    if (response.code == 404) {
                        swal({
                            type: 'warning',
                            title: "No hay resultados",
                            text: response.message,
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500,
                            onClose: () => {
                            }
                        }).then(() => {
                        }, (dismiss) => {
                        });
                    } else if (response.code == 500) {

                        swal({
                            type: 'warning',
                            title: 'Ha ocurrido un problema!',
                            text: response.message,
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500,
                            onClose: () => {
                                window.close()
                                // window.location.reload();
                            }
                        }).then(() => {
                        }, (dismiss) => {
                            window.close()
                            // window.location.reload();
                        });
                    }
                }


            }, error => {
                this.spinner.hide()
                console.log(error)
                this.errorMessage = JSON.parse(error._body)
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                })
            })
        } else if (this.nombre_conjunto.valid) {
            console.log("entre en nombre conjunto")
            this._user.buscar_direc_all({ nombre_conjunto: this.nombre_conjunto.value }).subscribe(response => {
                this.type = "conjunto";
                this.spinner.hide();
                if (response.done) {
                    this.buscando = true
                    this.dataBusqueda = (this.nombre_conjunto.value).toUpperCase()
                    console.log(response)
                    let data = response.body.response.data
                    this.resultados = [...data];
                    console.log(this.resultados)
                } else {
                    if (response.code == 404) {
                        swal({
                            type: 'warning',
                            title: "No hay resultados",
                            text: response.message,
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500,
                            onClose: () => {
                            }
                        }).then(() => {
                        }, (dismiss) => {
                        });
                    } else if (response.code == 500) {

                        swal({
                            type: 'warning',
                            title: 'Ha ocurrido un problema!',
                            text: response.message,
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500,
                            onClose: () => {
                                window.close()
                                // window.location.reload();
                            }
                        }).then(() => {
                        }, (dismiss) => {
                            window.close()
                            // window.location.reload();
                        });
                    }
                }

            })
        }

    }

    openPerfil() {
        this.dialog.open(PerfilComponent)
    }

    volver() {
        this.buscando = false;
        this.verDetalle = false;
        this.rol.setValue("");
        this.calle.setValue("");
        this.nroCalle.setValue("");
        this.nombre_conjunto.setValue("");
        this.fecha_ingreso.setValue("");
        this.resultados = []
    }


    traerDetalles(index, type) {
        let fechax
        let fechay
        console.log(index)
        this.detalleSeleccionado = this.resultados[index];
        console.log("detalle seleccionado", this.detalleSeleccionado)
        // Usuario_Modificacion_Fecha
        fechax = this.detalleSeleccionado.fieldData['Usuario_Modificacion_Fecha']
        console.log("fecha x Usuario_Modificacion_Fecha", fechax)
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") { fechay = "" }
        this.detalleSeleccionado.fieldData['Usuario_Modificacion_Fecha'] = fechay

        // Conj_Hab_Resoluciones::CHRS_Resol_Fecha
        for (let index = 0; index < this.detalleSeleccionado.portalData.Conj_Hab_Resoluciones.length; index++) {
            const element = this.detalleSeleccionado.portalData.Conj_Hab_Resoluciones[index];
            fechax = this.detalleSeleccionado.portalData.Conj_Hab_Resoluciones[index]['Conj_Hab_Resoluciones::CHRS_Resol_Fecha']
            console.log("fecha x permiso", fechax)
            fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
            if (fechay == "Invalid date") { fechay = "" }
            this.detalleSeleccionado.portalData.Conj_Hab_Resoluciones[index]['Conj_Hab_Resoluciones::CHRS_Resol_Fecha'] = fechay
        }

        // Conj_Hab_Recepciones
        for (let index = 0; index < this.detalleSeleccionado.portalData.Conj_Hab_Recepciones.length; index++) {
            const element = this.detalleSeleccionado.portalData.Conj_Hab_Recepciones[index];
            fechax = this.detalleSeleccionado.portalData.Conj_Hab_Recepciones[index]['Conj_Hab_Recepciones::CHRP_Fecha']
            console.log("fecha x recepcion", fechax)
            fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
            if (fechay == "Invalid date") { fechay = "" }
            this.detalleSeleccionado.portalData.Conj_Hab_Recepciones[index]['Conj_Hab_Recepciones::CHRP_Fecha'] = fechay
        }

        // Conj_Hab_Permiso
        for (let index = 0; index < this.detalleSeleccionado.portalData.Conj_Hab_Permiso.length; index++) {
            const element = this.detalleSeleccionado.portalData.Conj_Hab_Permiso[index];
            fechax = this.detalleSeleccionado.portalData.Conj_Hab_Permiso[index]['Conj_Hab_Permiso::CHP_Perm_Fecha_Otorgado']
            console.log("fecha x permiso", fechax)
            fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
            if (fechay == "Invalid date") { fechay = "" }
            this.detalleSeleccionado.portalData.Conj_Hab_Permiso[index]['Conj_Hab_Permiso::CHP_Perm_Fecha_Otorgado'] = fechay
        }


        this.buscando = false;
        this.verDetalle = true;
        console.log(this.detalleSeleccionado);
    }

    verConjunto(e) {
        console.log(e)
    }
}



export class Marcador {
    public lat: number;
    public lng: number;
    public titulo = 'Sin titulo';

    constructor(lat: number, lng: number, titulo: string) {
        this.lat = lat;
        this.lng = lng;
        this.titulo = titulo
    }
}

